const styles = {
    content: {
        maxWidth: "200px",
        overflowWrap: "break-word",
        overflow: "hidden"
    },
    editButton: {
        marginRight: "10px"
    },
    grab: {
        cursor: "grab"
    }
}

export default styles